<template>
  <div class="timestamp">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>Unix 时间戳转换</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-card class="tool-card">
            <div slot="header">当前时间戳</div>
            <div class="current-timestamp">
              <div class="ts-value">{{ currentTimestamp }}</div>
              <div class="ts-label">秒</div>
              <el-divider></el-divider>
              <div class="ts-value">{{ currentTimestampMs }}</div>
              <div class="ts-label">毫秒</div>
            </div>
            <el-button type="primary" size="small" @click="refresh">刷新</el-button>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="tool-card">
            <div slot="header">当前日期时间</div>
            <div class="current-time">
              <div class="time-value">{{ currentTime }}</div>
              <div class="time-label">{{ currentTimezone }}</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-card class="tool-card">
            <div slot="header">时间戳 → 日期</div>
            <el-input
              v-model="timestampInput"
              placeholder="输入时间戳（秒或毫秒）"
              clearable
              style="margin-bottom: 10px"
              @keyup.enter.native="convertToDate"
            ></el-input>
            <el-select v-model="timestampUnit" style="margin-bottom: 10px; width: 100%">
              <el-option label="秒" :value="1"></el-option>
              <el-option label="毫秒" :value="1000"></el-option>
            </el-select>
            <el-button type="primary" @click="convertToDate">转换</el-button>
            <div v-if="convertedDate" class="result-display">
              <div class="result-value">{{ convertedDate }}</div>
              <div class="result-label">转换结果</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="tool-card">
            <div slot="header">日期 → 时间戳</div>
            <el-date-picker
              v-model="dateInput"
              type="datetime"
              placeholder="选择日期和时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="margin-bottom: 10px; width: 100%"
            ></el-date-picker>
            <el-select v-model="targetTimezone" style="margin-bottom: 10px; width: 100%">
              <el-option label="UTC+8 (北京时间)" value="Asia/Shanghai"></el-option>
              <el-option label="UTC+0 (世界标准时间)" value="UTC"></el-option>
              <el-option label="UTC-5 (美国东部时间)" value="America/New_York"></el-option>
              <el-option label="UTC-8 (美国太平洋时间)" value="America/Los_Angeles"></el-option>
              <el-option label="UTC+9 (东京时间)" value="Asia/Tokyo"></el-option>
            </el-select>
            <el-button type="primary" @click="convertToTimestamp">转换</el-button>
            <div v-if="convertedTimestamp" class="result-display">
              <div class="result-value">{{ convertedTimestamp }}</div>
              <div class="result-label">秒</div>
              <div class="result-value" style="font-size: 24px; margin-top: 5px">{{ convertedTimestampMs }}</div>
              <div class="result-label">毫秒</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <el-card class="tool-card">
        <div slot="header">常用时间参考</div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="ref-item">
              <div class="ref-label">今天 00:00:00</div>
              <div class="ref-value">{{ todayStart }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="ref-item">
              <div class="ref-label">明天 00:00:00</div>
              <div class="ref-value">{{ tomorrowStart }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="ref-item">
              <div class="ref-label">本周一 00:00:00</div>
              <div class="ref-value">{{ weekStart }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px">
          <el-col :span="8">
            <div class="ref-item">
              <div class="ref-label">本月1日 00:00:00</div>
              <div class="ref-value">{{ monthStart }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="ref-item">
              <div class="ref-label">本季第一天</div>
              <div class="ref-value">{{ quarterStart }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="ref-item">
              <div class="ref-label">今年1月1日</div>
              <div class="ref-value">{{ yearStart }}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'timestamp',
  data () {
    return {
      currentTimestamp: 0,
      currentTimestampMs: 0,
      currentTime: '',
      currentTimezone: '',
      timestampInput: '',
      timestampUnit: 1,
      dateInput: '',
      targetTimezone: 'Asia/Shanghai',
      convertedDate: '',
      convertedTimestamp: '',
      convertedTimestampMs: '',
      todayStart: 0,
      tomorrowStart: 0,
      weekStart: 0,
      monthStart: 0,
      quarterStart: 0,
      yearStart: 0
    }
  },
  mounted () {
    this.refresh()
    this.updateTimezone()
    this.calculateCommonTimes()
    this.timer = setInterval(() => {
      this.refresh()
    }, 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    refresh () {
      const now = Date.now()
      this.currentTimestampMs = now
      this.currentTimestamp = Math.floor(now / 1000)
      this.currentTime = this.formatDate(new Date())
      this.calculateCommonTimes()
    },
    updateTimezone () {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      this.currentTimezone = tz
    },
    formatDate (date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },
    convertToDate () {
      if (!this.timestampInput) {
        this.$message.warning('请输入时间戳')
        return
      }
      try {
        let ts = parseInt(this.timestampInput)
        if (ts > 10000000000) {
          ts = Math.floor(ts / 1000)
        }
        this.convertedDate = this.formatDate(new Date(ts * 1000))
      } catch (e) {
        this.$message.error('时间戳格式错误')
      }
    },
    convertToTimestamp () {
      if (!this.dateInput) {
        this.$message.warning('请选择日期')
        return
      }
      try {
        const date = new Date(this.dateInput)
        this.convertedTimestamp = Math.floor(date.getTime() / 1000)
        this.convertedTimestampMs = date.getTime()
      } catch (e) {
        this.$message.error('日期格式错误')
      }
    },
    calculateCommonTimes () {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const tomorrow = new Date(today.getTime() + 86400000)
      const weekDay = now.getDay() || 7
      const monday = new Date(today.getTime() - (weekDay - 1) * 86400000)
      const monthFirst = new Date(now.getFullYear(), now.getMonth(), 1)
      const quarterMonth = Math.floor(now.getMonth() / 3) * 3
      const quarterFirst = new Date(now.getFullYear(), quarterMonth, 1)
      const yearFirst = new Date(now.getFullYear(), 0, 1)
      
      this.todayStart = Math.floor(today.getTime() / 1000)
      this.tomorrowStart = Math.floor(tomorrow.getTime() / 1000)
      this.weekStart = Math.floor(monday.getTime() / 1000)
      this.monthStart = Math.floor(monthFirst.getTime() / 1000)
      this.quarterStart = Math.floor(quarterFirst.getTime() / 1000)
      this.yearStart = Math.floor(yearFirst.getTime() / 1000)
    }
  }
}
</script>

<style scoped>
.timestamp {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.box-card {
  max-width: 1400px;
  margin: 0 auto;
}
.tool-card {
  text-align: center;
}
.current-timestamp, .current-time {
  margin: 20px 0;
}
.ts-value, .time-value {
  font-size: 32px;
  font-weight: bold;
  color: #409EFF;
  font-family: monospace;
}
.ts-label, .time-label {
  color: #909399;
  font-size: 14px;
  margin-top: 5px;
}
.result-display {
  margin-top: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
}
.result-value {
  font-size: 28px;
  font-weight: bold;
  color: #67C23A;
  font-family: monospace;
}
.result-label {
  color: #909399;
  font-size: 14px;
  margin-top: 5px;
}
.ref-item {
  text-align: center;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 8px;
}
.ref-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 5px;
}
.ref-value {
  font-family: monospace;
  font-size: 14px;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/view/timestamp.vue